module.exports = __webpack_public_path__ + "static/media/room-8.ebb7fca5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-8.jpeg
// module id = 83
// module chunks = 0